import type { SVGProps } from "react";

export function IconBlackNavConsumerServices(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 2.25H21.75V21.75H12.75V17.75H11.25V21.75H2.25V2.25ZM6.75 9.25V5.75H5.25V9.25H6.75ZM18.75 9.25V5.75H17.25V9.25H18.75ZM18.75 11.25V14.75H17.25V11.25H18.75ZM6.75 11.25V14.75H5.25V11.25H6.75ZM10.75 9.25V5.75H9.25V9.25H10.75ZM10.75 11.25V14.75H9.25V11.25H10.75ZM14.75 9.25V5.75H13.25V9.25H14.75ZM14.75 11.25V14.75H13.25V11.25H14.75Z"
        fill="#0B0C17"
      />
    </svg>
  );
}
